import { Button, Form, InputNumber, Modal } from 'antd'
import React, { memo, useCallback, useState } from 'react'
import { InputShippingDateI } from '../model/types/types'
import { PlusOutlined, EditOutlined } from '@ant-design/icons'
import { ModalShippingDate } from './modal/modal-shipping-date'
import './styles.css'
import InputDate from '../../input-date'
import { useSelector } from 'react-redux'
import { getDeliveryId } from '../../../pages_v2/deliveries/card/selectors'


interface PriceInputProps {
  UISchema: any
  props: InputShippingDateI
  onOpenModal: () => void
}

const formatCurrency = (value: number) => value
  .toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    currencyDisplay: 'code',
  })
  .replace(/\s*RUB/, '')

const ShippingDateInput: React.FC<PriceInputProps> = ({ UISchema, props, onOpenModal }) => {
  const {
    value,
    required,
  } = props

  return (
    <span>
      <Form.Item
        style={{ marginBottom: 0 }}
        required={required}
      >
        <InputDate
          value={value}
          onChange={() => {}}
          UISchema={{...UISchema, options: { disabled: true } }}
        />
      </Form.Item>
      <Button
        style={{
          width: '32px',
          flex: 'none',
        }}
        onClick={() => onOpenModal()}
        icon={<EditOutlined />}
      />
    </span>
  )
}

export const InputShippingDate: React.FC<InputShippingDateI> = memo((props: InputShippingDateI) => {
  const {
    required,
    value,
    UISchema
  } = props

  console.log('UISchema', UISchema)

  const deliveryId = useSelector(getDeliveryId)

  const [isOpenModalShipping, setIsOpenModalShipping] = useState<boolean>(false)

  const openModal = useCallback(async () => {
    setIsOpenModalShipping(true)
  }, [value, setIsOpenModalShipping])

  return (
    <>
      <Form.Item
        required={required}
        style={{ 'marginBottom': 0 }}
      >
        <ShippingDateInput
          props={props}
          onOpenModal={openModal}
          UISchema={UISchema}
        />
      </Form.Item>
      {
        Boolean(deliveryId) && (
          <ModalShippingDate
            entityId={deliveryId}
            date={value || ''}
            isOpen={isOpenModalShipping}
            onClose={() => setIsOpenModalShipping(false)}
          />
        )
      }
    </>
  )
})